var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"relative text-center"},[_vm._t("header")],2),_c('div',{staticClass:"mx-8 md:mx-24 mt-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }